<mat-progress-spinner
  mode="indeterminate"
  diameter="100"
  strokeWidth="8"
>
</mat-progress-spinner>
